import ErrorIcon from '~/assets/icons/Error';

type Props = React.HTMLProps<HTMLInputElement> & {
  backgroundTheme?: 'light' | 'dark';
  className?: string;
  error?: string;
  reference?: React.RefObject<HTMLInputElement>;
};

const defaultClassName = 'border rounded-md p-2 w-full h-12 text-base';

export default function TextInput({
  backgroundTheme = 'dark',
  className,
  reference,
  name,
  id,
  error,
  type,
  placeholder,
  required,
  onChange
}: Props) {
  return (
    <div className="relative flex w-full flex-col gap-2">
      <input
        className={className ?? defaultClassName}
        ref={reference}
        id={id}
        name={name}
        type={type}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={`${id}-error`}
        placeholder={placeholder}
        required={required}
        onChange={onChange}
      />
      {error && <ErrorMessage text={error} backgroundTheme={backgroundTheme} />}
    </div>
  );
}

function ErrorMessage({
  text,
  backgroundTheme
}: {
  backgroundTheme: Props['backgroundTheme'];
  text: string;
}) {
  return (
    <div
      data-cy="text-input-error"
      className="flex flex-row items-center justify-start gap-2"
    >
      <div className="shrink-0">
        <ErrorIcon />
      </div>
      <p
        className={`text-sm font-semibold ${backgroundTheme === 'light' ? 'text-black' : 'text-white'}`}
      >
        {text}
      </p>
    </div>
  );
}
